module.exports = __webpack_public_path__ + "img/mallorca-logo-icon.08df9d8c.png";